import { Tabs } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { useTranslation } from "react-i18next";

interface TabListWithCountsProps {
  currentTab: string;
  recommendedCount: number;
  learningCount: number;
  allCoursesCount: number;
}

export const TabListWithCounts: React.FC<TabListWithCountsProps> = ({
  currentTab,
  recommendedCount,
  learningCount,
  allCoursesCount,
}) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery("(max-width: 820px)");

  const renderTab = (value: string, label: string, count: number) => (
    <Tabs.Tab
      value={value}
      p={mobile ? 14 : undefined}
      style={{
        borderColor: currentTab === value ? undefined : "#dee2e6",
      }}
    >
      {label}
      <div
        style={{
          marginLeft: "8px",
          padding: "3px 8px",
          backgroundColor:
            currentTab === value ? "rgba(111, 66, 193, 0.2)" : "#f0f0f0",
          color: currentTab === value ? "#6F40E2" : "#333",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: "bold",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: currentTab === value ? 1 : 0.8,
        }}
      >
        {count}
      </div>
    </Tabs.Tab>
  );

  return (
    <Tabs.List
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        flexWrap: "nowrap",
        scrollBehavior: "smooth",
        WebkitOverflowScrolling: "touch",
        width: "100%",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {renderTab("Recommended", t("recommended_tab"), recommendedCount)}
      {renderTab("My learning", t("my_learning_tab"), learningCount)}
      {renderTab("All Courses", t("all_courses_tab"), allCoursesCount)}
    </Tabs.List>
  );
};
